import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { Store } from "@ngrx/store";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { BauteilWithReports } from "@partikelart/portal/shared-typing";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { Observable } from "rxjs";
import { loadPartsForUser } from "../+state/export.actions";
import { currentPartsForUserForExport, loadingPartsForExport, numberOfPartsSelected } from "../+state/export.selectors";
import { DataExportService } from "../data-export.service";
import { MultiExportPartTableComponent } from "../multi-export-part-table/multi-export-part-table.component";
import { MultiExportReportTableComponent } from "../multi-export-report-table/multi-export-report-table.component";

@Component({
	selector: "partikelart-multi-export-start-page",
	templateUrl: "./multi-export-start-page.component.html",
	styleUrls: ["./multi-export-start-page.component.scss"],
	standalone: true,
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		TranslatePipe,
		CardModule,
		ButtonModule,
		RouterModule,
		MultiExportReportTableComponent,
		MultiExportPartTableComponent,
	],
})
export class MultiExportStartPageComponent implements OnInit {
	bauteileWithReports$: Observable<BauteilWithReports[]>;
	partsLoading$: Observable<boolean>;
	currentSelectedBauteile$: Observable<number>;
	constructor(
		private exportService: DataExportService,
		private translate: TranslateService,
		private store: Store,
	) {
		this.currentSelectedBauteile$ = this.store.select(numberOfPartsSelected);
		this.partsLoading$ = this.store.select(loadingPartsForExport);
		this.bauteileWithReports$ = this.store.select(currentPartsForUserForExport);
	}

	ngOnInit(): void {
		this.exportService.setCurrentStep(0);
		this.currentSelectedBauteile$.subscribe((number) => {
			if (number === 0) this.store.dispatch(loadPartsForUser());
		});
	}
	selectOrDeselect(bauteil: BauteilWithReports) {
		this.exportService.selectOrDeselect([bauteil]);
	}
}
